import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import type { DailyCheckInRound } from '../../model/dailyCheckIn/types';

/** `GET /v2/daily-check-ins/current-round` — 진행 중인 7일 회차. 회차가 없어도 `isActive:false` 객체가 온다. */
export const getDailyCheckInRound = async (): Promise<DailyCheckInRound> => {
  const response = await serviceApi.dailyCheckIn.getCurrentRound(withServiceRequestDefaults());

  return response.data.data;
};
